import React, { Component } from 'react';
import { withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import { Elements } from 'react-stripe-elements';
import GateFeeProcessing from '../AA/gateFee/GateFeeProcessing';
import '../AA/gateFee/GateFee.css';

class GateFeeBoarding_pay extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {
        try {
            let overDom = document.getElementById("newBoarding_pay_View");
            if(overDom){
              let height1 = document.getElementById('promo-banner-container-second').offsetHeight
              overDom.style.top = (height1)+'px';
            }
        } catch (error) {
        }
    }

    render() {
        return (
            <div className="publicView" style={{marginBottom:'100px',boxSizing:'border-box',paddingTop:'18px'}}>
                <div className="plan-area-style gateFee-style" style={{ backgroundColor: '#ffff',textAlign:'center'}}>
                    <div className="gate-fee-body">
                        <div className="gatefee-checkout-custom">
                            <div name="purchase-view" id="gate-fee">
                                <div style={{marginBottom: '14px'}} className="skin-type-hello-title">Complete your purchase</div>
                                <Elements>
                                    <GateFeeProcessing
                                        showThankYouMessage={ this.state.showThankYou }
                                        firstName={localStorage.getItem('user_firstname')  }
                                        lastName={ localStorage.getItem('user_lastname')   }
                                        phoneNumber={ localStorage.getItem('user_global_phone')}
                                        email={ localStorage.getItem('user_global_email') }
                                        planValue={10}
                                        paymentType = {'BOARDING_PAY'}
                                        fun_changeStepStep = {this.props.fun_changeStepStep}
                                    />
                                </Elements>
                            </div>
                        </div>
                    </div>
                </div>
            </div>        
        )
    }
}

export default withRouter(connect()(GateFeeBoarding_pay))



// WEBPACK FOOTER //
// ./src/views/onboardingAA/GateFeeBoarding_pay.js